/* Shushmate cart page (sections/sm-cart.liquid).
   - Quantity and remove buttons change the cart, then the section re-renders in place
     (Section Rendering API), so the page never reloads.
   - The "one more band" offer adds the band in the picked colour (a single in the cart becomes a
     Couples 2-Pack) and applies the offer code.
   - The offer code is removed again once the cart has no offer line or fewer than two bands.
   - Phones get a sticky checkout bar while the main checkout button is off screen. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url = function (path) { return (root + path).replace(/\/{2,}/g, '/'); };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var cartEl = function () { return $('[data-sm-cart]'); };

  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  /* The offer code stays only while an offer line is in the cart and there are 2+ bands */
  function shouldDropCode(cart) {
    var el = cartEl();
    var code = el && el.getAttribute('data-code');
    if (!code) return false;
    var applied = (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
    if (!applied) return false;
    var pair = el.getAttribute('data-pair-pack');
    var bands = 0, offer = false;
    cart.items.forEach(function (i) {
      var isPair = (i.options_with_values || []).some(function (o) { return o.value === pair; }) ||
        !!(i.properties && i.properties['Band 2 colour']);
      bands += i.quantity * (isPair ? 2 : 1);
      if (i.properties && i.properties._offer) offer = true;
    });
    return !(offer && bands >= 2);
  }

  function render(data, opts) {
    var el = cartEl();
    var id = el.getAttribute('data-section');
    var html = data.sections && data.sections[id];
    if (!html) { window.location.reload(); return; }
    var box = document.getElementById('shopify-section-' + id);
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id);
    if (!box || !fresh) { window.location.reload(); return; }
    if (window.smTrimWallets) window.smTrimWallets(doc);
    var eta = $('[data-sm-eta]', el);
    var etaText = eta && eta.textContent;
    box.innerHTML = fresh.innerHTML;
    var newEta = $('[data-sm-eta]', box);
    if (newEta && etaText) newEta.textContent = etaText;
    $$('[data-reveal]', box).forEach(function (r) { r.classList.add('is-in'); });
    if (opts && opts.highlight) {
      var line = $('.sm-line--offer', box);
      if (line) line.classList.add('is-new');
    }
    setCount(data.item_count);
    setup();
  }

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Header cart bubble */
  function setCount(n) {
    if (typeof n !== 'number') return;
    var link = $('.sm-head a[href$="/cart"]');
    if (!link) return;
    var bubble = $('.sm-iconbtn__count', link);
    link.setAttribute('aria-label', 'Cart, ' + n + ' items');
    if (!n) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('span');
      bubble.className = 'sm-iconbtn__count';
      link.appendChild(bubble);
    }
    bubble.textContent = n;
  }

  /* Apply a cart change, dropping the offer code if the change made it ineligible */
  function change(promise, opts) {
    var el = cartEl();
    var id = el.getAttribute('data-section');
    el.classList.add('is-busy');
    return promise
      .then(function (data) {
        if (shouldDropCode(data)) return post('cart/update.js', { discount: '', sections: id });
        return data;
      })
      .then(function (data) { render(data, opts); })
      .catch(function () { window.location.reload(); });
  }

  /* Quantity, remove ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sm-cart] [data-sm-qty]');
    if (!btn) return;
    var line = btn.closest('[data-sm-line]');
    line.classList.add('is-busy');
    change(post('cart/change.js', {
      id: line.getAttribute('data-key'),
      quantity: parseInt(btn.getAttribute('data-sm-qty'), 10),
      sections: cartEl().getAttribute('data-section')
    }));
  });

  /* Offer: colour picker -------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sm-offer] input[name="sm-offer-colour"]');
    if (!input) return;
    var offer = input.closest('[data-sm-offer]');
    var img = $('[data-sm-offer-img]', offer);
    var label = $('[data-sm-offer-name]', offer);
    if (label) label.textContent = input.value;
    if (img && input.getAttribute('data-img')) {
      img.src = input.getAttribute('data-img');
      img.classList.remove('is-pop');
      void img.offsetWidth;
      img.classList.add('is-pop');
    }
  });

  /* Offer: add ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sm-offer-add]');
    if (!btn) return;
    var el = cartEl();
    var offer = btn.closest('[data-sm-offer]');
    var mode = offer.getAttribute('data-mode');
    var picked = $('input[name="sm-offer-colour"]:checked', offer);
    var colour = picked ? picked.value : 'Black';
    var code = el.getAttribute('data-code');
    var keep = offer.getAttribute('data-keep') || 'Black';
    /* The colour's own variant (snippets/sm-variant-map.liquid), so checkout shows its photo */
    var map = null;
    try { map = JSON.parse(($('#sm-vmap') || {}).textContent || 'null'); } catch (err) { map = null; }
    var id = map && map[btn.getAttribute('data-pack') + '|' + (mode === 'pair' ? keep + ' + ' + colour : colour)];
    var props = mode === 'pair'
      ? { 'Band 1 colour': keep, 'Band 2 colour': colour, _offer: 'pair' }
      : { Colour: colour, _offer: 'more' };
    /* The variant carries the colour; the notes are only needed on the old pack-only product */
    if (id) props = { _offer: mode };
    btn.setAttribute('aria-busy', 'true');
    change(post('cart/add.js', { items: [{ id: Number(id || btn.getAttribute('data-variant')), quantity: 1, properties: props }] })
      .then(function () {
        var body = { sections: el.getAttribute('data-section') };
        /* A single becomes the 2-Pack: the old single line goes */
        if (mode === 'pair') { body.updates = {}; body.updates[btn.getAttribute('data-line')] = 0; }
        if (code) body.discount = code;
        return post('cart/update.js', body);
      }), { highlight: true });
  });

  /* Checkout buttons show a spinner while checkout loads */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest('[data-sm-cart]')) return;
    $$('[data-sm-checkout]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) $$('[aria-busy="true"]').forEach(function (b) { b.removeAttribute('aria-busy'); });
  });

  /* Sticky checkout bar (phones): shows while the main checkout button is still below the screen */
  var tick = false;
  function placeSticky() {
    tick = false;
    var main = document.getElementById('sm-cart-checkout');
    var sticky = $('[data-sm-cart-sticky]');
    if (!main || !sticky) return;
    var show = main.getBoundingClientRect().top > window.innerHeight - 20;
    if ((sticky.getAttribute('data-visible') === 'true') === show) return;
    sticky.setAttribute('data-visible', show ? 'true' : 'false');
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    var btn = $('button', sticky);
    if (btn) btn.tabIndex = show ? 0 : -1;
  }
  function onScroll() { if (!tick) { tick = true; window.requestAnimationFrame(placeSticky); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function setup() { placeSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
